import { GET_SERVICE_RESTART_ERROR_CODES, GET_SERVICE_RESTART_LOGS } from "./actionTypes";

const initialState = {
  errorCodeList: [],
  errorCodeListErrorMessage: null,
  epeLogs: [],
  epeLogsErrorMessage: null,
};

const serviceRestartLogsReducer = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case GET_SERVICE_RESTART_ERROR_CODES.SUCCESS:
      return {
        ...state,
        errorCodeList: action.payload,
        errorCodeListErrorMessage: null,
      };
    case GET_SERVICE_RESTART_ERROR_CODES.ERROR:
      return {
        ...state,
        errorCodeList: [],
        errorCodeListErrorMessage: action.payload,
      };
    case GET_SERVICE_RESTART_LOGS.SUCCESS:
      return {
        ...state,
        epeLogs: action.payload,
        epeLogsErrorMessage: null,
      };
    case GET_SERVICE_RESTART_LOGS.ERROR:
      return {
        ...state,
        epeLogs: [],
        epeLogsErrorMessage: action.payload,
      };
    default:
      return { ...state };
  }
};

export default serviceRestartLogsReducer;
